import React, { FC, useState } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { OutsideClick } from '@src/components/OutsideClick';
import MenuVerticalSvg from '@src/svgs/menu-vertical.svg';
import { ListPopover } from '../ListPopover';
import { Position } from './enums/position.enum';
import { ActionMenuPopoverProps } from './props';
import './styles.scss';

export const ActionMenuPopover: FC<ActionMenuPopoverProps> = ({
  actions,
  wrapperClassName,
  iconClassName,
  popoverClassName,
  onAction,
  position = Position.BOTTOM,
}) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <OutsideClick addOutsideClickListener={isShown} onOutsideClick={() => setIsShown(false)}>
      <div className={classnames('fr-action-popover', wrapperClassName)}>
        <span
          className={classnames('fr-action-popover__icon', iconClassName)}
          onClick={e => {
            e.stopPropagation();

            setIsShown(!isShown);
          }}
        >
          <Svg src={MenuVerticalSvg} />
        </span>

        {!!actions && (
          <ListPopover
            className={classnames(
              'fr-action-popover__popover',
              `fr-action-popover__popover--${position}`,
              popoverClassName,
            )}
            isShown={isShown}
            list={actions}
            onItemClick={item => {
              if (onAction) {
                onAction(item);
              }

              setIsShown(false);
            }}
          />
        )}
      </div>
    </OutsideClick>
  );
};
